import React from 'react';
import PropTypes from 'prop-types';
import {Banner} from '@albert-io/atomic';
import {getModelForResourceType} from 'resources/modelRegistry';
import {useShallow} from 'zustand/react/shallow';

import {useQuestionTranslationStore} from '../TranslationSection';

import {isGuessOrDraftGuessEmpty} from '../../../../AssignmentPracticeView/assignmentPracticeView.utils';

const ResultIndicatorBar = ({guess, additionalInfo}) => {
  const {showTranslations} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question
    }))
  );

  const isCorrect = guess.isCorrect();
  // If a guess doesn't have an ID, we can assume it doesn't
  // exist in the DB, so the guess was never submitted.
  const isUnsubmitted = !guess.getId() || isGuessOrDraftGuessEmpty(guess);
  let bannerCopy = isCorrect ? 'Correct' : 'Incorrect';

  const translatedBannerCopy = isCorrect ? 'Correcto' : 'Incorrecto';

  if (isUnsubmitted) {
    bannerCopy = 'No answer was submitted for this question';
  }
  return (
    <div className='u-mar-b_4'>
      <Banner type={isCorrect ? 'positive' : 'negative'}>
        <Banner.Icon icon={isCorrect ? 'check' : 'times'} />
        {!showTranslations &&
          bannerCopy
            .concat(additionalInfo || isUnsubmitted ? '. ' : '')
            .concat(additionalInfo || '')}
        {showTranslations && translatedBannerCopy}
      </Banner>
    </div>
  );
};

ResultIndicatorBar.propTypes = {
  guess: PropTypes.instanceOf(getModelForResourceType('guess_v1')),
  additionalInfo: PropTypes.string
};

export {ResultIndicatorBar};
